<app-loader></app-loader>
<div class="share-invoice-outer">
  <div class="model-heading">
    <div class="inner-heading">
      <h4>Share Invoice</h4>
      <div class="close-icon" (click)="close()"><img src="../../../../assets/images/new-close.svg" alt=""/></div>
    </div>
    <p>{{userEmail ? userEmail : userMobileNumber}}</p>
  </div>
  <hr />

  <div class="add-recipients">
    <h5>Add More Recipients <span>(Optional)</span> </h5>
    <p #errorDiv class="pass-err">{{error}}</p>
    <div class="recipients-email">
      <label for="newEmail">Email</label>
      <div class="recipient-inner">
        <input [(ngModel)]="newEmail" id="newEmail" (ngModelChange)="clearError()" placeholder="Enter Recipient’s Email" type="text" pInputText />
        <button class="btn" [ngClass]="{
          'btn-disable': !newEmail?.trim(),
          'btn-active': newEmail?.trim()
        }"  [disabled]="!newEmail?.trim()" (click)="addRecipient()">Add Recipient</button>
      </div>

      <div *ngIf="emails?.length > 0" class="email-list">
        <span *ngFor="let email of emails" class="email-chip">
          {{ email }}
          <img class="remove-icon" (click)="removeRecipient(email)"
            src="../../../../assets/images/close-inputlist.svg" alt="Close"/>
        </span>
      </div>

      <div *ngIf="!hideGuideLines" class="multiple-outer">
        <h3>You can enter multiple email addresses separated by commas.</h3>
        <p>(e.g., user1&#64;example.com, user2&#64;example.com).</p>
      </div>

      <div class="pay-now">
        <p-button [disabled]="!!error" label="Send" (onClick)="sendInvoice()"></p-button>
      </div>
    </div>
  </div>
</div>